export default __webpack_public_path__ + "static/media/(23).f009aad0.jpeg";